import { api } from "../../api/http";

export async function createCompany(payload) {
	const res = await api.post("/api/backoffice/companies/", payload);
	return res.data;
}

export async function createCompanyAdmin(companyId, payload) {
	const res = await api.post(
		`/api/backoffice/companies/${companyId}/admins/`,
		payload,
	);
	return res.data;
}

export async function getCompany(id) {
	const res = await api.get(`/api/backoffice/companies/${id}/`);
	return res.data;
}

export async function listCompanies(params = {}) {
	const res = await api.get("/api/backoffice/companies/", { params });
	return res.data;
}

export async function listCompanyAdmins(companyId) {
	const res = await api.get(`/api/backoffice/companies/${companyId}/admins/`);
	return res.data;
}

export async function disableCompanyAdmin(companyId, adminId) {
	const res = await api.post(
		`/api/backoffice/companies/${companyId}/admins/${adminId}/disable/`,
	);
	return res.data;
}

export async function enableCompanyAdmin(companyId, adminId) {
	const res = await api.post(
		`/api/backoffice/companies/${companyId}/admins/${adminId}/enable/`,
	);
	return res.data;
}

export async function resetCompanyAdminPassword(companyId, adminId) {
	const res = await api.post(
		`/api/backoffice/companies/${companyId}/admins/${adminId}/reset-password/`,
	);
	return res.data;
}

export async function lookupCourses(params = {}) {
	const res = await api.get("/api/backoffice/courses-lookup/", { params });
	return res.data;
}

/** Runs (curso + fechas) para asignar a empresa. El run define el periodo de vigencia (2x1). */
export async function lookupCourseRuns(params = {}) {
	const res = await api.get("/api/backoffice/course-runs-lookup/", {
		params,
	});
	return res.data;
}

export async function updateCompany(id, payload) {
	const res = await api.patch(`/api/backoffice/companies/${id}/`, payload);
	return res.data;
}

export async function deleteCompany(id, payload = { confirm_delete: true }) {
	const res = await api.delete(`/api/backoffice/companies/${id}/`, {
		data: payload,
	});
	return res.data;
}

export async function listCompanyContractsMaster(companyId) {
	const res = await api.get(
		`/api/backoffice/companies/${companyId}/contracts-master/`,
	);
	return res.data;
}

export async function createCompanyContractMaster(companyId, payload) {
	const res = await api.post(
		`/api/backoffice/companies/${companyId}/contracts-master/`,
		payload,
	);
	return res.data;
}

export async function updateCompanyContractMaster(
	companyId,
	contractId,
	payload,
) {
	const res = await api.patch(
		`/api/backoffice/companies/${companyId}/contracts-master/${contractId}/`,
		payload,
	);
	return res.data;
}

export async function listCompanyEntitlements(companyId) {
	const res = await api.get(
		`/api/backoffice/companies/${companyId}/entitlements/`,
	);
	return res.data;
}

export async function createCompanyEntitlement(companyId, payload) {
	const res = await api.post(
		`/api/backoffice/companies/${companyId}/entitlements/`,
		payload,
	);
	return res.data;
}

export async function updateCompanyEntitlement(
	companyId,
	entitlementId,
	payload,
) {
	const res = await api.patch(
		`/api/backoffice/companies/${companyId}/contracts/${entitlementId}/`,
		payload,
	);
	return res.data;
}

export async function generateCompanyCode(companyId) {
	const res = await api.post(
		`/api/backoffice/companies/${companyId}/generate-code/`,
		{},
	);
	return res.data; // { code }
}
